// @flow
export { default } from "components/Modal"
